
import { useEffect, useState } from 'react';

const Hero = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoaded(true);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <section className="h-[66.67vh] flex items-center justify-center relative overflow-hidden">
      {/* Background Video */}
      <video
        className="absolute inset-0 w-full h-full object-cover"
        autoPlay
        muted
        loop
        playsInline
      >
        <source src="https://public.readdy.ai/ai/video_res/edce5d22-133c-4ed5-9d13-c730ff3af061.mp4" type="video/mp4" />
      </video>

      {/* Content Container */}
      <div className="relative z-10 w-full max-w-6xl mx-auto px-8 text-center">
        {/* Main Content */}
        <div className={`transform transition-all duration-2000 ${isLoaded ? 'translate-y-0 opacity-100' : 'translate-y-12 opacity-0'}`}>
          {/* Brand Slogan */}
          <div className="text-center">
            <h1 
              className="text-4xl md:text-5xl lg:text-6xl font-thin text-white mb-8 leading-relaxed" 
              style={{ fontFamily: 'PingFang SC, -apple-system, BlinkMacSystemFont, sans-serif', lineHeight: 1.3, fontWeight: 100 }}
            >
              养于内<br />美于外
            </h1>
          </div>
          
          {/* Subtitle */}
          <div className={`transform transition-all duration-2000 delay-500 ${isLoaded ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'}`}>
            <p 
              className="text-lg lg:text-3xl text-white mb-4 font-light"
              style={{ fontFamily: 'Noto Serif SC, serif' }}
            >
              宫廷养森 · 以内养外，焕发原生之美
            </p>
            <p 
              className="text-sm lg:text-base text-white/90 max-w-2xl mx-auto leading-relaxed"
              style={{ fontFamily: 'PingFang SC, -apple-system, BlinkMacSystemFont, sans-serif', fontWeight: 100 }}
            >
              传承千年宫廷古方智慧，融合现代中医验证，为您呈现内调外养的完整解决方案
            </p>
          </div>
        </div>
      </div>

      {/* Decorative Elements */}
      <div className="absolute top-1/4 left-1/4 w-2 h-2 bg-red-600/30 rounded-full animate-pulse"></div>
      <div className="absolute top-1/3 right-1/3 w-1 h-1 bg-red-600/20 rounded-full animate-pulse delay-1000"></div>
      <div className="absolute bottom-1/4 right-1/4 w-3 h-3 bg-red-600/20 rounded-full animate-pulse delay-500"></div>
    </section>
  );
};

export default Hero;
